
<div class="row" >
  <div class="col-12">
    <colors alpha :mode="mode"/>
  </div>
</div>
